
import { AfterViewInit, Component, ElementRef, ViewChild,Input } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';

declare var google: any;

@Component({
    selector: 'app-pie-chart-year-revenue',
    template: `<div #pieChart style="width: 100%; height: 100%;"></div>`
})
export class PieChartYearRevenueComponent implements AfterViewInit {

    @ViewChild('pieChart') pieChart: ElementRef

    yr: any;

    @Input() set countRevenue(countRevenue: number) {
      this.yr = countRevenue;
      const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
      const options = {
        //pieSliceText: 'value',
        legend: { position: 'top' }
      };
      var  getYearRevenue5: any;
      this.dashboardService.getYearRevenue()
      .pipe(first())
      .subscribe(
          data => {
              console.log("getYearRevenue response---", data)
              getYearRevenue5 = data.respData;


              var data1 = [];
              var Header = ['Element', 'Density'];
              data1.push(Header);
              for (var i = 0; i < data.respData.length; i++) {
                  var temp = [];
                  temp.push(data.respData[i].year);
                  temp.push(data.respData[i].totalAmt);

                  data1.push(temp);
              }
              var chartdata = new google.visualization.arrayToDataTable(data1);
              chart.draw(chartdata, options);
          },
          error => {
              console.log(error)
          }
      )      
    }

    constructor(private dashboardService: DashboardService) { }

    chartdata: any;
    // getYearRevenue: any;
    result = [];
    drawChart = () => {
        let datatbl = google.visualization.arrayToDataTable([
            ['Task', 'Hours per Day'],           
        ]);
        var  getYearRevenue6: any;
        this.dashboardService.getYearRevenue()
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getYearRevenue response---", data)
                    getYearRevenue6 = data.respData;


                    var data1 = [];
                    var Header = ['Element', 'Density'];
                    data1.push(Header);
                    for (var i = 0; i < data.respData.length; i++) {
                        var temp = [];
                        temp.push(data.respData[i].year);
                        temp.push(data.respData[i].totalAmt);

                        data1.push(temp);
                    }
                    var chartdata = new google.visualization.arrayToDataTable(data1);
                    chart.draw(chartdata, options);
                },
                error => {
                    console.log(error)
                }
            )
        const options = {
          // pieSliceText: 'value',
            legend: { position: 'top' }
        };
        const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
    }

    ngAfterViewInit() {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(this.drawChart);
    }
}